import {SseNotification} from './sse-notification.model';

export class VetClinicInfoDataSyncNotification extends SseNotification {

  constructor() {
    super();
  }
}
